import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductConsultaComponent } from './product-consulta.component';
import { OneClickPurchaseModule } from '../one-click-purchase/one-click-purchase.module';

@NgModule({
  declarations: [ProductConsultaComponent], // Declara o componente
  imports: [CommonModule,OneClickPurchaseModule], // Importa módulos necessários
  exports: [ProductConsultaComponent] // Exporta para ser reutilizado
})
export class ProductConsultaModule {}
